<!-- https://loading.io/spinner/double-ring/-double-ring-spinner -->

<template>
  <div class="lds-css">
    <div
      class="lds-dual-ring"
      :style="style"
    >
      <div class="lds-external-ring" :style="externalRingStyle" />
      <div class="lds-internal-ring" :style="internalRingStyle" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sizeUnit: {
      type: String,
      default: 'rem',
    },
    totalSize: {
      type: Number,
      default: 5,
    },
    internalRingSize: {
      type: Number,
      default: 3,
    },
    internalRingThickness: {
      type: Number,
      default: 0.2,
    },
    internalRingColor: {
      type: String,
      default: 'white',
    },
    externalRingSize: {
      type: Number,
      default: 4,
    },
    externalRingThickness: {
      type: Number,
      default: 0.2,
    },
    externalRingColor: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    style () {
      const half = this.totalSize / 2 + this.sizeUnit
      return {
        width: this.totalSize + this.sizeUnit,
        height: this.totalSize + this.sizeUnit,
        WebkitTransform: `translate(-${half}, -${half}) scale(1) translate(${half}, ${half})`,
        transform: `translate(-${half}, -${half}) scale(1) translate(${half}, ${half})`,
      }
    },
    internalRingStyle () {
      const margins = (this.totalSize - this.internalRingSize) / 2
      return {
        width: this.internalRingSize + this.sizeUnit,
        height: this.internalRingSize + this.sizeUnit,
        top: margins + this.sizeUnit,
        left: margins + this.sizeUnit,
        border: `${this.internalRingThickness}${this.sizeUnit} solid ${this.internalRingColor}`,
        borderColor: `transparent ${this.internalRingColor} transparent ${this.internalRingColor}`,
      }
    },
    externalRingStyle () {
      const margins = (this.totalSize - this.externalRingSize) / 2
      return {
        width: this.externalRingSize + this.sizeUnit,
        height: this.externalRingSize + this.sizeUnit,
        top: margins + this.sizeUnit,
        left: margins + this.sizeUnit,
        border: `${this.externalRingThickness}${this.sizeUnit} solid ${this.externalRingColor}`,
        borderColor: `transparent ${this.externalRingColor} transparent ${this.externalRingColor}`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes lds-dual-ring {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes lds-dual-ring {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes lds-dual-ring_reverse {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
@-webkit-keyframes lds-dual-ring_reverse {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
.lds-dual-ring {
  position: relative;
  margin: auto;
}
.lds-dual-ring div {
  position: absolute;
  border-radius: 50%;
}
.lds-external-ring {
  -webkit-animation: lds-dual-ring 1s linear infinite;
  animation: lds-dual-ring 1s linear infinite;
}
.lds-internal-ring {
  -webkit-animation: lds-dual-ring_reverse 1s linear infinite;
  animation: lds-dual-ring_reverse 1s linear infinite;
}
</style>
